"use strict";
// (C) 2007-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDynamicScriptLoadSdkError = exports.isCancelledSdkError = exports.isUnknownSdkError = exports.isProtectedReport = exports.isNotFound = exports.isNoDataSdkError = exports.isNegativeValues = exports.isDataTooLargeToCompute = exports.isDataTooLargeToDisplay = exports.isGeoTokenMissing = exports.isGeoLocationMissing = exports.isUnauthorized = exports.isBadRequest = exports.isGoodDataSdkError = exports.DynamicScriptLoadSdkError = exports.CancelledSdkError = exports.UnexpectedSdkError = exports.ProtectedReportSdkError = exports.NotFoundSdkError = exports.NoDataSdkError = exports.NegativeValuesSdkError = exports.DataTooLargeToComputeSdkError = exports.DataTooLargeToDisplaySdkError = exports.GeoTokenMissingSdkError = exports.GeoLocationMissingSdkError = exports.UnauthorizedSdkError = exports.BadRequestSdkError = exports.GoodDataSdkError = exports.ErrorCodes = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Error codes recognized by the SDK.
 *
 * @public
 */
exports.ErrorCodes = {
    BAD_REQUEST: "BAD_REQUEST",
    UNAUTHORIZED: "UNAUTHORIZED",
    GEO_LOCATION_MISSING: "GEO_LOCATION_MISSING",
    GEO_MAPBOX_TOKEN_MISSING: "GEO_MAPBOX_TOKEN_MISSING",
    DATA_TOO_LARGE_TO_DISPLAY: "DATA_TOO_LARGE_TO_DISPLAY",
    DATA_TOO_LARGE_TO_COMPUTE: "DATA_TOO_LARGE_TO_COMPUTE",
    NEGATIVE_VALUES: "NEGATIVE_VALUES",
    NO_DATA: "NO_DATA",
    NOT_FOUND: "NOT_FOUND",
    PROTECTED_REPORT: "PROTECTED_REPORT",
    UNKNOWN_ERROR: "UNKNOWN_ERROR",
    CANCELLED: "CANCELLED",
    DYNAMIC_SCRIPT_LOAD_ERROR: "DYNAMIC_SCRIPT_LOAD_ERROR",
};
/**
 * Base class for all anticipated GoodData.UI SDK errors.
 *
 * @public
 */
var GoodDataSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(GoodDataSdkError, _super);
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    function GoodDataSdkError(seType, message, cause) {
        var _newTarget = this.constructor;
        var _this = 
        /*
         * This is here to keep exception handling in client code initially backward compatible. Previosly
         * GoodDataSdkError had the error code inside the message itself. Keeping it that way.
         *
         * Note: using || instead of ?? so that code falls back to use error type even on empty message
         */
        _super.call(this, message || seType) || this;
        _this.seType = seType;
        _this.cause = cause;
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain
        return _this;
    }
    /**
     * Provides description of the problem or one of {@link ErrorCodes}.
     */
    GoodDataSdkError.prototype.getMessage = function () {
        return this.message;
    };
    /**
     * Underlying cause of this error (if any).
     */
    GoodDataSdkError.prototype.getCause = function () {
        return this.cause;
    };
    /**
     * Error code for this exception. This can be used to identify exact type of exception.
     */
    GoodDataSdkError.prototype.getErrorCode = function () {
        return this.seType;
    };
    return GoodDataSdkError;
}(Error));
exports.GoodDataSdkError = GoodDataSdkError;
/**
 * This error means that server could not understand the request due to invalid syntax.
 *
 * @public
 */
var BadRequestSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(BadRequestSdkError, _super);
    function BadRequestSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.BAD_REQUEST, message, cause) || this;
    }
    return BadRequestSdkError;
}(GoodDataSdkError));
exports.BadRequestSdkError = BadRequestSdkError;
/**
 * This error means that you are not authorized.
 *
 * @public
 */
var UnauthorizedSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(UnauthorizedSdkError, _super);
    function UnauthorizedSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.UNAUTHORIZED, message, cause) || this;
    }
    return UnauthorizedSdkError;
}(GoodDataSdkError));
exports.UnauthorizedSdkError = UnauthorizedSdkError;
/**
 * This error means that location bucket is missing
 *
 * @public
 */
var GeoLocationMissingSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(GeoLocationMissingSdkError, _super);
    function GeoLocationMissingSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.GEO_LOCATION_MISSING, message, cause) || this;
    }
    return GeoLocationMissingSdkError;
}(GoodDataSdkError));
exports.GeoLocationMissingSdkError = GeoLocationMissingSdkError;
/**
 * This error means that mapbox token of GeoChart is missing
 *
 * @public
 */
var GeoTokenMissingSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(GeoTokenMissingSdkError, _super);
    function GeoTokenMissingSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.GEO_MAPBOX_TOKEN_MISSING, message, cause) || this;
    }
    return GeoTokenMissingSdkError;
}(GoodDataSdkError));
exports.GeoTokenMissingSdkError = GeoTokenMissingSdkError;
/**
 * This error means that executed data were too large to be displayed by GoodData.UI.
 *
 * @public
 */
var DataTooLargeToDisplaySdkError = /** @class */ (function (_super) {
    tslib_1.__extends(DataTooLargeToDisplaySdkError, _super);
    function DataTooLargeToDisplaySdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.DATA_TOO_LARGE_TO_DISPLAY, message, cause) || this;
    }
    return DataTooLargeToDisplaySdkError;
}(GoodDataSdkError));
exports.DataTooLargeToDisplaySdkError = DataTooLargeToDisplaySdkError;
/**
 * This error means that processed request would generate a result too large to be processed
 * by GoodData platform.
 *
 * @public
 */
var DataTooLargeToComputeSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(DataTooLargeToComputeSdkError, _super);
    function DataTooLargeToComputeSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.DATA_TOO_LARGE_TO_COMPUTE, message, cause) || this;
    }
    return DataTooLargeToComputeSdkError;
}(GoodDataSdkError));
exports.DataTooLargeToComputeSdkError = DataTooLargeToComputeSdkError;
/**
 * This error means that processed result contains negative values which does not make
 * sense within the given visualization (e.g. pie chart with negative values).
 *
 * @public
 */
var NegativeValuesSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(NegativeValuesSdkError, _super);
    function NegativeValuesSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.NEGATIVE_VALUES, message, cause) || this;
    }
    return NegativeValuesSdkError;
}(GoodDataSdkError));
exports.NegativeValuesSdkError = NegativeValuesSdkError;
/**
 * This error means that the processed result does not contain any data.
 *
 * @public
 */
var NoDataSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(NoDataSdkError, _super);
    function NoDataSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.NO_DATA, message, cause) || this;
    }
    return NoDataSdkError;
}(GoodDataSdkError));
exports.NoDataSdkError = NoDataSdkError;
/**
 * This error means that requested entity (e.g. a visualization) was not found on the server.
 *
 * @public
 */
var NotFoundSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(NotFoundSdkError, _super);
    function NotFoundSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.NO_DATA, message, cause) || this;
    }
    return NotFoundSdkError;
}(GoodDataSdkError));
exports.NotFoundSdkError = NotFoundSdkError;
/**
 * This error means that requested visualization is restricted by access rules within the GoodData platform.
 * Please contact your administrator.
 *
 * @public
 */
var ProtectedReportSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(ProtectedReportSdkError, _super);
    function ProtectedReportSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.PROTECTED_REPORT, message, cause) || this;
    }
    return ProtectedReportSdkError;
}(GoodDataSdkError));
exports.ProtectedReportSdkError = ProtectedReportSdkError;
/**
 * This error means that GoodData.UI does not know how to handle such error.
 *
 * @public
 */
var UnexpectedSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(UnexpectedSdkError, _super);
    function UnexpectedSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.UNKNOWN_ERROR, message, cause) || this;
    }
    return UnexpectedSdkError;
}(GoodDataSdkError));
exports.UnexpectedSdkError = UnexpectedSdkError;
/**
 * This error means that request has been cancelled usually after component has been unmounted.
 *
 * @public
 */
var CancelledSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(CancelledSdkError, _super);
    function CancelledSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.CANCELLED, message, cause) || this;
    }
    return CancelledSdkError;
}(GoodDataSdkError));
exports.CancelledSdkError = CancelledSdkError;
/**
 * This error means that loading of dynamic script/plugin failed.
 *
 * @public
 */
var DynamicScriptLoadSdkError = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicScriptLoadSdkError, _super);
    function DynamicScriptLoadSdkError(message, cause) {
        return _super.call(this, exports.ErrorCodes.DYNAMIC_SCRIPT_LOAD_ERROR, message, cause) || this;
    }
    return DynamicScriptLoadSdkError;
}(GoodDataSdkError));
exports.DynamicScriptLoadSdkError = DynamicScriptLoadSdkError;
//
//
//
/**
 * Typeguard checking whether input is an instance of {@link GoodDataSdkError};
 *
 * @public
 */
function isGoodDataSdkError(obj) {
    return !isEmpty_1.default(obj) && obj.seType !== undefined;
}
exports.isGoodDataSdkError = isGoodDataSdkError;
/**
 * Typeguard checking whether input is an instance of {@link BadRequestSdkError};
 *
 * @public
 */
function isBadRequest(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "BAD_REQUEST";
}
exports.isBadRequest = isBadRequest;
/**
 * Typeguard checking whether input is an instance of {@link UnauthorizedSdkError};
 *
 * @public
 */
function isUnauthorized(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "UNAUTHORIZED";
}
exports.isUnauthorized = isUnauthorized;
/**
 * Typeguard checking whether input is an instance of {@link GeoLocationMissingSdkError};
 *
 * @public
 */
function isGeoLocationMissing(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "GEO_LOCATION_MISSING";
}
exports.isGeoLocationMissing = isGeoLocationMissing;
/**
 * Typeguard checking whether input is an instance of {@link GeoTokenMissingSdkError};
 *
 * @public
 */
function isGeoTokenMissing(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "GEO_MAPBOX_TOKEN_MISSING";
}
exports.isGeoTokenMissing = isGeoTokenMissing;
/**
 * Typeguard checking whether input is an instance of {@link DataTooLargeToDisplaySdkError};
 *
 * @public
 */
function isDataTooLargeToDisplay(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "DATA_TOO_LARGE_TO_DISPLAY";
}
exports.isDataTooLargeToDisplay = isDataTooLargeToDisplay;
/**
 * Typeguard checking whether input is an instance of {@link DataTooLargeToComputeSdkError};
 *
 * @public
 */
function isDataTooLargeToCompute(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "DATA_TOO_LARGE_TO_COMPUTE";
}
exports.isDataTooLargeToCompute = isDataTooLargeToCompute;
/**
 * Typeguard checking whether input is an instance of {@link NegativeValuesSdkError};
 *
 * @public
 */
function isNegativeValues(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "NEGATIVE_VALUES";
}
exports.isNegativeValues = isNegativeValues;
/**
 * Typeguard checking whether input is an instance of {@link NoDataSdkError};
 *
 * @public
 */
function isNoDataSdkError(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "NO_DATA";
}
exports.isNoDataSdkError = isNoDataSdkError;
/**
 * Typeguard checking whether input is an instance of {@link NotFoundSdkError};
 *
 * @public
 */
function isNotFound(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "NOT_FOUND";
}
exports.isNotFound = isNotFound;
/**
 * Typeguard checking whether input is an instance of {@link ProtectedReportSdkError};
 *
 * @public
 */
function isProtectedReport(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "PROTECTED_REPORT";
}
exports.isProtectedReport = isProtectedReport;
/**
 * Typeguard checking whether input is an instance of {@link UnexpectedSdkError};
 *
 * @public
 */
function isUnknownSdkError(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "UNKNOWN_ERROR";
}
exports.isUnknownSdkError = isUnknownSdkError;
/**
 * Typeguard checking whether input is an instance of {@link CancelledSdkError};
 *
 * @public
 */
function isCancelledSdkError(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "CANCELLED";
}
exports.isCancelledSdkError = isCancelledSdkError;
/**
 * Typeguard checking whether input is an instance of {@link DynamicScriptLoadSdkError};
 *
 * @public
 */
function isDynamicScriptLoadSdkError(obj) {
    return !isEmpty_1.default(obj) && obj.seType === "DYNAMIC_SCRIPT_LOAD_ERROR";
}
exports.isDynamicScriptLoadSdkError = isDynamicScriptLoadSdkError;
//# sourceMappingURL=GoodDataSdkError.js.map